import OdooSummaryPanel from './OdooSummaryPanel.vue';

/**
 * Extension point for conversation-sidebar panels that don't yet warrant
 * touching ContactPanel.vue's existing, high-traffic v-else-if chain
 * (rendered on every open conversation - hundreds of times a day per the
 * ops profile this app is built for). The existing panels
 * (conversation_actions, contact_notes, shared_files, etc.) each have
 * genuinely different prop shapes and conditional-rendering logic (see
 * ContactPanel.vue), so a fully generic registry for *all* of them would
 * trade working, well-understood code for indirection with no real
 * benefit. This registry instead covers the actual forward-looking need:
 * a place for genuinely NEW panels (Odoo, AI summary, VitalPBX, ...) to
 * register themselves without editing the orchestrator.
 *
 * To add a new panel:
 *   1. Build a `<YourPanel />` component (props: none required by the
 *      registry itself - reach into the store/composables the same way
 *      the existing panels do, e.g. `useMapGetter('getSelectedChat')`).
 *   2. Add an entry below.
 *   3. Add `{ name: 'your_panel_name' }` to
 *      `DEFAULT_CONVERSATION_SIDEBAR_ITEMS_ORDER` in
 *      composables/useUISettings.js so it's included in the reorderable
 *      list and gets a per-agent open/closed + order preference for free.
 *
 * ContactPanel.vue renders whichever of these matches the current
 * drag-order item's `name` via a single generic branch - no further
 * per-panel wiring needed there.
 *
 * No `icon` field: `AccordionItem`'s `icon` prop goes through the
 * deprecated `EmojiOrIcon` -> `fluent-icon` system (old Fluent icon
 * names, e.g. "add"/"subtract" - not `i-lucide-*` unocss classes), and
 * none of the 9 existing panels in ContactPanel.vue pass one either.
 * Mismatching the two crashes `fluent-icon` at render time (caught via
 * live browser verification, not by any unit test - see
 * CHANGELOG_BAVLY.md).
 */
export const FUTURE_SIDEBAR_PANELS = [
  {
    name: 'odoo_info',
    titleKey: 'CONVERSATION_SIDEBAR.ACCORDION.ODOO_INFO',
    component: OdooSummaryPanel,
  },
];

export const getFutureSidebarPanel = name =>
  FUTURE_SIDEBAR_PANELS.find(panel => panel.name === name);
